module.exports = __webpack_public_path__ + "static/media/students-in-classroom.66a2dcfd.svg";